
    import PageHeader from '../../components/Layout/PageHeader.vue';
    import MostRead from '../../components/News/MostRead.vue';
    import Newest from '../../components/News/Newest.vue';

    export default {
        async asyncData({ params, $axios }) {
            // console.log(params.slug);
            var slug = decodeURI(params.slug);
            slug = slug.replace(/_/g, " ");

            var loading = true;
            var news;

            const result = await $axios.get(`/news?slug=${slug}`);
            news = result.data.data;
            loading = false;

            loading = false;
            
            return { news, loading, slug }
        },
        // metaInfo() {
        //     return {
        //         title: this.$route.params.news_title,
        //         // meta: [
        //         //     { vmid: 'og:image', name: 'og:image', content: 'https://nod.ba/images/nod_logo_header.png' },
        //         //     { vmid: 'description', name: 'description', content: description},
        //         //     { vmid: 'og:description', name: 'og:description', content: description}
        //         // ]
        //         meta: this.sitemeta,
        //     };
        // },
        head() {
            return {
                title: this.news.title,
                meta: [
                    {
                        hid: 'og-title',
                        property: 'og:title',
                        content: this.news.title,
                    },
                    {
                        hid: 'og-url',
                        property: 'og:url',
                        content: 'https://nod.ba/novost/' + this.news.slug,
                    },
                    {
                        hid: 'og-type',
                        property: 'og:type',
                        content: 'website',
                    },
                    {
                        hid: 'og-image',
                        property: 'og:image',
                        content: this.$axios.defaults.baseURL + '/image?imagePath=' + this.news.image
                    },
                    {
                        hid: 'description',
                        property: 'description',
                        content: this.news.title
                    },
                    {
                        hid: 'og-description',
                        property: 'og:description',
                        content: this.news.title
                    },
                    // other meta
                ],
            };
        },
        computed: {
            get_tab_class: (data) => (tab_name) => {
                var classes = "tab";
                if (data.active_tab == tab_name) {
                    classes += " active";
                }
                return classes;
            },
            is_tab_open: (data) => (tab_name) => {
                var classes = "tab__content";
                if (data.active_tab !== tab_name) {
                    classes += " closed";
                }
                else {
                }
                return classes;
            },
            get_lession_card_classes: (data) => (tab_index) => {
                var classes = "education__lession_expandable";
                if (data.current_lession_index === tab_index) {
                    classes += " expanded";
                }
                return classes;
            },
            get_tab_icon_src: (data) => (tab_index) => {
                if (data.current_lession_index === tab_index) {
                    return "~/assets/images/icons/.png";
                }
                else {
                    return "~/assets/images/icons/plus.png";
                }
            },
            get_lession_description_classes: (data) => (tab_index) => {
                var classes = "description";
                if (data.current_lession_index === tab_index) {
                    classes += " expanded";
                }
                return classes;
            }
        },
        created() {
            // this.fetchNewsArticle();
        },
        mounted() {
            // console.log('Component mounted.')
        },
        methods: {
            // async fetchNewsArticle() {
            //     this.loading = true;
            //     const result = await this.$axios.get(`/news?slug=${this.slug}`);
            //     this.news = result.data.data;
            //     this.loading = false;
            // },
            toAuthor() {
                // this.$router.push({ name: "autor", params: { author_name: this.news.mentioned_author.author_name } });
                this.$router.push({
                    path: '/autor/'+this.news.mentioned_author.author_name
                })
            },
            // setMetaTags(){
            //     this.sitemeta = [
            //         { vmid: 'og:url', name: 'og:url', content: 'https://nod.ba/' },
            //         { vmid: 'og:image', name: 'og:image', content: window.axios.defaults.baseURL + '/image?imagePath=' + this.news.image },
            //         { vmid: 'description', name: 'description', content: 'Nod.ba | Novost | ' + this.news.title },
            //         { vmid: 'og:description', name: 'og:description', content: 'Nod.ba | Novost | ' + this.news.title }
            //     ];
            // }
        },
        components: { PageHeader, MostRead, Newest }
    }
